module.exports = __webpack_public_path__ + "img/chest-immortal.54005a05.svg";